import script from "./ReportsCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsCatalog.vue?vue&type=script&setup=true&lang=js"

import "./ReportsCatalog.vue?vue&type=style&index=0&id=68c70c2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c70c2f"]])

export default __exports__